// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import $ from 'jquery'
import utils from './utils/index.js'
import api from './api/index.js'
import echarts from 'echarts'
// import echartswordcloud from 'echarts-wordcloud'
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import axios from 'axios';
import "babel-polyfill"
import md5 from 'js-md5';

Vue.use(vuescroll);

Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.prototype.$echarts = echarts
Vue.prototype.$axios=axios;
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
   el: '#app',
   router,
   components: { App },
   template: '<App/>',

})


//检测路由跳转
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    // 登录检测
    let host = window.location.host;
    if(host === 'hot.nybkz.com'){//线上
      // if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登录
      //    let cooke = document.cookie.indexOf("_gsdataCL");
      //    if (cooke != -1) { // 查询本地存储信息的方案信息
      //          next();
      //    } else {
      //       //next({path:'/login'})
      //       window.location.href="https://u1.nybkz.com/member/login?url=http://"+host+"/";
      //    }
      // } else {
      //    next();
      // }
    }else {
      next();
   }
});



// WEBPACK FOOTER //
// ./src/main.js